import { App_Url_New } from "@/shared/common/static";
import { openModal } from "@/shared/redux/reducers/uiSlice";
import { useAppDispatch } from "@/shared/redux/store/hooks";
import { usePosterReducers } from "@/shared/redux/store/useGetData";
import { App_Url, getWhatsAppUrl } from "@/whiteLable";
const CHATBOT_BASE_URL =
  import.meta.env.VITE_APP_CHATBOT_URL || "https://insurehubrag.nexsysit.co.in";

const getChatbotBaseUrl = () => CHATBOT_BASE_URL.replace(/\/+$/, "");

function getChatbotUrlForRole(roleName: unknown) {
  const normalizedRole = String(roleName || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");

  const isAdminRole = normalizedRole.includes("admin");
  const rolePath = isAdminRole ? "" : "/agent-dashboard";

  const baseUrl = getChatbotBaseUrl();
  return rolePath ? `${baseUrl}${rolePath}` : baseUrl;
}

function addCacheBuster(chatbotUrl: string) {
  const url = new URL(chatbotUrl);
  url.searchParams.set("t", String(Date.now()));
  return url.toString();
}

type ChatbotAuthParams = {
  token?: string;
  agentName?: string;
};

function addChatbotAuthParams(chatbotUrl: string, authParams: ChatbotAuthParams) {
  const url = new URL(chatbotUrl);

  if (authParams.token) {
    url.searchParams.set("token", authParams.token);
  }

  if (authParams.agentName) {
    url.searchParams.set("agentName", authParams.agentName);
  }

  return url.toString();
}

export default function FloatingButtons() {
  const openWhatsApp = () => {
    window.open(getWhatsAppUrl(), "_blank", "noopener,noreferrer");
  };
  const { auth: user } = usePosterReducers();
  const dispatch = useAppDispatch();
  const isAuthenticated = Boolean(user.user?.access_token);
  const authenticatedUser = user.user as any;
  const backendSignedToken = authenticatedUser?.access_token || "";
  const role = authenticatedUser?.role || authenticatedUser?.user?.role;
  const roleName =
    role?.name || role?.display_name || role?.role_name || (typeof role === "string" ? role : "");
  const agentName = authenticatedUser?.user?.full_name;
  const chatbotAuthParams: ChatbotAuthParams = {
    token: backendSignedToken,
    agentName,
  };

  const chatbotUrl = getChatbotUrlForRole(roleName);
  console.log("chatbotUrl", chatbotUrl);
  const normalizedRole = String(roleName || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_]+/g, "-");
  const isAdmin = normalizedRole.includes("admin");

  const openChatbot = () => {
    const iframeUrl = !isAuthenticated
      ? getChatbotBaseUrl()
      : isAdmin
        ? undefined
        : addCacheBuster(addChatbotAuthParams(chatbotUrl, chatbotAuthParams));

    if (iframeUrl) {
      console.log("chatbotRedirectUrl", iframeUrl);
      console.log("chatbotQueryData", {
        token: chatbotAuthParams.token,
        agentName: chatbotAuthParams.agentName,
      });
    }

    dispatch(
      openModal({
        name: App_Url_New.PopupKeys.OPEN_CHAT_BOT,
        data: {
          iframeUrl,
          chatbotOptions:
            isAuthenticated && isAdmin
              ? [
                  {
                    label: "Document Upload",
                    url: addCacheBuster(
                      addChatbotAuthParams(`${getChatbotBaseUrl()}/admin`, chatbotAuthParams)
                    ),
                  },
                  {
                    label: "Agent Monitoring",
                    url: addCacheBuster(
                      addChatbotAuthParams(`${getChatbotBaseUrl()}/super-admin`, chatbotAuthParams)
                    ),
                  },
                ]
              : undefined,
        },
      })
    );
  };

  const buttonClass =
    "flex items-center justify-center rounded-full " +
    "w-12 h-12 md:w-14 md:h-14 " +
    "bg-transparent shadow-lg " +
    "transition-transform duration-200 hover:scale-105 active:scale-95";

  const iconClass = "w-10 h-10 md:w-12 md:h-12 object-contain";

  const containerPosition = isAuthenticated
    ? "fixed bottom-4 left-4 md:bottom-6 md:left-6"
    : "fixed bottom-4 right-4 md:bottom-6 md:right-6";
  return (
    <div className={`${containerPosition} z-40 flex flex-col gap-2 md:gap-3`}>
      {/* WhatsApp Button */}
      {!isAuthenticated && (
        <button
          type="button"
          aria-label="Chat on WhatsApp"
          onClick={openWhatsApp}
          className={buttonClass}
        >
          <img src={App_Url.public.Whatsapp} alt="WhatsApp" className={iconClass} />
        </button>
      )}

      {/* Chatbot Button */}
      <button type="button" aria-label="Open Chatbot" onClick={openChatbot} className={buttonClass}>
        <img src={App_Url.public.ChatBot} alt="Chatbot" className={iconClass} />
      </button>
    </div>
  );
}
